/**
 * @description Directory for ID Attributes on Merchant Switcher.
 * Naming Convention: "data-test-id-[VIEW/COMPONENT]-[ELEMENT]-[NAME]".
 * Example: id = "data-test-id-mainlayout-btn-cancel".
 */
 const idDirectory = {
    divRoot: `merchantSwitcher-div-root`,
}

export default idDirectory